import createPlugin from '@@/create-plugin';

export default createPlugin({
    components: {
        'page:menu:item': () => import('./components/menu')
    }
});
